import type { HbmlElementNode } from "@holibob-packages/hbml";

import { HbmlRendererNodes } from "../HbmlRenderer";

export function HbmlListItemContentNode({ content }: { content: HbmlElementNode }) {
    return <HbmlRendererNodes content={content.children} />;
}
